import models from './models' // This have to be relative import as long as backend and frontend shares modules.

export default {
  global: {
    actionBarHeight: 0,
    showIntercom: false,
    fetching: 0,
    language: 'en',
    session: {
      user: {
        companyId: {
          features: {},
        },
        joyride: {},
      },
    },
    region: {
      host: '',
      geolocation: '',
    },
    notifications: [
    ],
    navigationMenu: null,
    sort: {
      videos: 'createdAt',
      applications: 'createdAt',
      jobAds: 'createdAt',
      interviews: 'createdAt',
      candidates: {
        sortName: 'rowId',
        sortOrder: 'desc',
        page: 1,
      },
      lives: 'status',
    },
    filter: {
      applications: '',
      jobAds: '',
      interviews: '',
      candidates: '',
      lives: '',
    },
    paginate: {
      itemsPerPage: 5,
      currentPage: 1,
    },
    video: null,
    videoPlayer: null,
    openQuestion: null,
    bgOptions: {
      background: null,
      blurAmount: 0,
    },
    files: {},
    messages: [],
    videoUploads: [],
    embedded: false,
    recorder: '',
    recording: false,
    websocketError: '',
    opentok: {
      testSessionData: {},
      candidateSessionData: {},
      recordingSessionData: {},
      recording: false,
      streaming: false,
      streamStarting: false,
      reconnecting: false,
      responseSaved: false,
      error: '',
      connectionCount: 0,
    },
  },

  ...models,

}
